<template>
    <div class="page-container">

        <div class="page-header" :class="{ 'active' : showPageHeader }">

            <div class="container-fluid">
                <div class="page-title">{{ pageTitle }}</div>
            </div>

        </div>

        <button class="btn btn-primary btn-register show" @click="openCustomModal()"
                v-if="hasValidSubscription && (subscription_status.status === 'active' || subscription_status.status === 'ending')">
            <img src="/images/card/register-button-icon.svg">Registrera behandling
        </button>

        <transition name="modal">
            <modal-punch
                :card="null"
                :employee_part_payment_type="employee_part_payment_type"
                :employee_part_payment_amount="employee_part_payment_amount"
                :treatment_duration="treatment_duration"
                @close="() => {
                    registerModalVisible = false
                    fetcherFetch()
                    closeCustomModal()
                }"
                v-if="registerModalVisible"
            />
        </transition>

        <transition name="modal">
            <router-view></router-view>
        </transition>

        <div class="page-body">

            <div class="container-fluid">
                <h1>{{ pageTitle }}</h1>

                <div class="placeholder-glow w-100" :class="{ 'd-none' : fetcher.initialized }">
                    <span class="placeholder bg-info col-24 mb-8 rounded-2" style="height: 48px;"></span>
                    <span class="placeholder bg-info col-4 mb-3 rounded-1" style="height: 24px;"></span>
                    <span class="placeholder bg-info col-24 mb-4 rounded-2" style="height: 80px;"></span>
                    <span class="placeholder bg-info col-24 mb-4 rounded-2" style="height: 80px;"></span>
                    <span class="placeholder bg-info col-24 mb-4 rounded-2" style="height: 80px;"></span>
                    <span class="placeholder bg-info col-24 mb-4 rounded-2" style="height: 80px;"></span>
                    <span class="placeholder bg-info col-24 mb-4 rounded-2" style="height: 80px;"></span>
                </div>

                <div v-if="fetcher.initialized">

                    <p class="mb-8">Här ser du en historik över alla dina behandlingar och eventuell kostnad som dras från
                    din friskvård eller lön. {{ employee_description }}</p>

                    <div :key="'y'+year" v-for="year in years">

                        <h2 class="text-dark">{{ year }}</h2>

                        <transition-group class="list" name="treatment-list" tag="div">

                            <div class="list-item treatment" :key="'t'+treatment.id"
                                 v-for="treatment in treatmentsInYear(year)">
                                <div class="row">
                                    <div class="col-15">
                                        <h4>{{ niceTreatmentAt(treatment.treatment_at) }}</h4>
                                        <p>
                                            <router-link tag="span" class="clinic-link"
                                                         :to="{name: 'treatments-clinic', params: {clinic: treatment.clinic_id}}">
                                                <img src="/images/card/clinic-location-icon.svg">
                                                {{ treatment.clinic_public.card_name_clinic }}
                                            </router-link>
                                        </p>
                                    </div>
                                    <div class="col-9 text-end">
                                        <div
                                            v-if="treatment.employee_part_payment_type === 'salary' || treatment.employee_part_payment_type === 'allowance'">
                                            <h4>{{ treatment.employee_part_payment_amount }} kr</h4>
                                            <p>från
                                                {{
                                                    treatment.employee_part_payment_type === 'salary' ? 'lön' : 'friskvård'
                                                }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </transition-group>

                    </div>

                </div>

            </div>

        </div>

    </div>
</template>

<script>
import moment from 'moment'

import scrollMixin from '../../../shared/mixins/scrollMixin'
import fetcher from '../../../shared/mixins/fetcher'

import modalPunch from '../shared/modal-punch'

import jQuery from 'jquery'

export default {

    mixins: [
        scrollMixin,
        fetcher
    ],

    components: {
        modalPunch
    },

    data () {
        return {
            pageTitle: 'Behandlingar',
            showPageHeader: false,
            loadingList: true,

            modal_clinic_id: null,

            registerModalVisible: false,
            clinicModalVisible: false,

            registeringStep2: false,
            loadingRegistering: false,
            registeringError: false,
            registeringCode: '',
            showRegisteredTreatment: false,

            currentDate: '',
            months: ['jan', 'feb', 'mars', 'april', 'maj', 'juni', 'juli', 'aug', 'sept', 'okt', 'nov', 'dec'],

            hasValidSubscription: true,
            employee_part_payment_type: null,
            employee_part_payment_amount: 0,
            employee_description: '',
            treatments: [],
            treatment_duration: '',
            fetcher: {
                autoFill: [
                    'treatments',
                    'employee_part_payment_type',
                    'employee_part_payment_amount',
                    'employee_description',
                    'treatment_duration'
                ]
            }
        }
    },

    mounted () {
        setTimeout(() => {
            this.loadingList = false
        }, 1000)
    },

    computed: {
        fetcherUrl () {
            return '/treatments'
        },
        years () {
            return [...new Set(this.treatments.map(t => moment(t.treatment_at).year()))]
        }
    },

    methods: {

        treatmentsInYear (year) {
            return this.treatments.filter(t => moment(t.treatment_at).year() === year)
        },

        niceTreatmentAt (treatment_at) {
            return moment(treatment_at).locale('sv').format('D MMM YYYY')
        },

        handleScroll (event) {
            const scrollTop = event.target.scrollingElement.scrollTop
            if (scrollTop > 50) {
                this.showPageHeader = true
            } else {
                this.showPageHeader = false
            }
        },

        openCustomModal () {
            this.registerModalVisible = true
            jQuery('html').addClass('modal-open')
        },

        closeCustomModal () {
            jQuery('html').removeClass('modal-open')
        }

    }
}
</script>
<style type="text/css">
/* --- Transition modal --- */
.modal-enter-active .custom-modal-window, .modal-leave-active .custom-modal-window {
    transform:translate(0, 0);
    transition: all 400ms ease-out;
}

.modal-enter .custom-modal-window, .modal-leave-to .custom-modal-window {
    transform:translate(0, 100%);
}

/* --- Transition treatments list --- */
.treatment-list-enter-active, .treatment-list-leave-active
{
    transition:margin 750ms ease, padding 750ms ease, max-height 750ms ease, transform 1000ms ease;
    overflow: hidden;
}
.treatment-list-enter,
.treatment-list-leave-to {
  max-height: 0px;
  margin:0;
  padding:0;
  transform: scale(1,0);
}
.treatment-list-enter-to,
.treatment-list-leave {
  max-height: 120px;
}

</style>
